import { Component, signal } from '@angular/core';
import { DeviceStatusFormComponent } from "@app/components/forms/device-status/form.component";
import { DeviceStatusHelperService } from '@app/services/helpers/device-status-helper.service';
import { Router, RouterModule } from '@angular/router';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { DeviceStatusCreate } from '@app/models/device-status.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { HeadMetaComponent } from '@app/components/ui.component';
import { ToastService } from '@app/services/toast.service';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-device-status-create',
    templateUrl: './create.page.html',
    styleUrl: './create.page.scss',
    imports: [
        HeadMetaComponent,
        DeviceStatusFormComponent,
        RouterModule,
        FontAwesomeModule,
        HelpButtonComponent
    ]
})
export class DeviceStatusCreatePage {
  public title = 'New Device Status';
  formValid = signal(false);
  formValue = signal<DeviceStatusCreate | null>(null);

  faArrowLeft = faArrowLeft;

  constructor(
    private deviceStatusService: DeviceStatusHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    
  }

  create() {
    let val = this.formValue();
    if(val) {
      this.deviceStatusService.create(val)
        .subscribe({
          next: id => {
            console.log(id)
            if(id) {
              this.router.navigateByUrl('/device-statuses/' + id);
            }
          },
          error: (err: AppHttpError) => {
            console.log(err.error)
            this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
          }
        });
    }
  }
}
